import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="App-content">
      <h1>Termeni și condiții</h1>
    </div>
  );
};

export default TermsAndConditions;
